import { createRouter, createWebHistory } from 'vue-router';
import LoginView from '../views/LoginView.vue';
import RegisterView from '../views/RegisterView.vue';
import DashboardView from '../views/DashboardView.vue';
import AddonsView from '../views/AddonsView.vue';
import AddonPackagesView from '../views/AddonPackagesView.vue';
import MenusView from '../views/MenusView.vue';
import QuoteEntriesView from '../views/QuoteEntriesView.vue';
import QuoteEntryPreviewView from '../views/QuoteEntryPreviewView.vue';
import CustomersView from '../views/CustomersView.vue';
import ImportedOrdersView from '../views/ImportedOrdersView.vue';
import OnlineOrdersView from '../views/OnlineOrdersView.vue';
import ImportedOrderDetailView from '../views/ImportedOrderDetailView.vue';
import ComebackOffersView from '../views/ComebackOffersView.vue';
import ProteinsView from '../views/ProteinsView.vue';
import StatisticsView from '../views/StatisticsView.vue';
import UsersView from '../views/UsersView.vue';
import { useAuthStore } from '../stores';

const routes = [
  {
    path: '/',
    name: 'LoginView',
    component: LoginView
  },
  {
    path: '/register',
    name: 'RegisterView',
    component: RegisterView
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardView,
    meta: { requiresAuth: true }
  },
  {
    path: '/addons',
    name: 'Addons',
    component: AddonsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/addon-packages',
    name: 'AddonPackages',
    component: AddonPackagesView,
    meta: { requiresAuth: true }
  },
  {
    path: '/menus',
    name: 'Menus',
    component: MenusView,
    meta: { requiresAuth: true }
  },
  {
    path: '/quotes',
    name: 'QuoteEntries',
    component: QuoteEntriesView,
    meta: { requiresAuth: true }
  },
  {
    path: '/quotes/:id/preview',
    name: 'QuoteEntryPreview',
    component: QuoteEntryPreviewView,
    meta: { requiresAuth: true }
  },
  {
    path: '/customers',
    name: 'Customers',
    component: CustomersView,
    meta: { requiresAuth: true }
  },
  {
    path: '/customers/:customerId/orders/:orderId',
    name: 'CustomerOrderView',
    component: () => import('../views/CustomerOrderView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/online-orders',
    name: 'OnlineOrders',
    component: OnlineOrdersView,
    meta: { requiresAuth: true }
  },
  {
    path: '/comeback-offers',
    name: 'ComebackOffers',
    component: ComebackOffersView,
    meta: { requiresAuth: true }
  },
  {
    path: '/order-totals',
    name: 'ImportedOrders',
    component: ImportedOrdersView,
    meta: { requiresAuth: true }
  },
  {
    path: '/order-totals/:id',
    name: 'ImportedOrderDetail',
    component: ImportedOrderDetailView,
    meta: { requiresAuth: true }
  },
  {
    path: '/proteins',
    name: 'Proteins',
    component: ProteinsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/statistics',
    name: 'Statistics',
    component: StatisticsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'Users',
    component: UsersView,
    meta: { requiresAuth: true }
  },
  {
    path: '/docs',
    name: 'ApiDocs',
    // Lazy-loaded so swagger-ui stays out of the main bundle.
    component: () => import('../views/ApiDocsView.vue'),
    meta: { requiresAuth: true }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  const isAuth = authStore.isAuthenticated;
  const publicPages = ['LoginView', 'RegisterView'];
  const isPublicPage = publicPages.includes(to.name);

  if (!isAuth && !isPublicPage) {
    // Not authenticated and trying to access a protected page
    next({ name: 'LoginView' });
  } else if (isAuth && isPublicPage) {
    // Authenticated user trying to access login or register
    next({ name: 'Dashboard' });
  } else {
    // All other cases
    next();
  }
});

export default router; 